import { POST } from "../API"
let source;
export const inviteContactApi = (phoneNumber, onSuccess, onError) => {
    const data = {
        phone_number: phoneNumber
    }
    source = POST(`/api/v1/chat/contacts/invite`, data, onSuccess, onError, true, source)
}